<template lang="pug">
  v-app
    router-view
</template>

<script>
import Login from "./pages/main/Login";
export default {
    name: "App",
    components: { Login },
    mounted() {
      this.$http.get("/x-key");
    }
};
</script>

